
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick, watchEffect, watch, onUnmounted } from 'vue'
import { PlusOutlined, MinusOutlined } from '@ant-design/icons-vue'
import { askApi } from '@/api/index'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import stock from '@/utils/stock'
import { message, Modal } from 'ant-design-vue'
import store from '@/store/index'
import { useStore, mapState, mapMutations, mapActions } from 'vuex'
import Askcollapse from '@/components/asktheSecretary/askcollapse.vue'
import globalsets from '@/utils/globalsets'
import Nodata from '@/components/page/nodata.vue'
import ws from '../../websocket/index'
export default defineComponent({
  components: {
    PlusOutlined,
    MinusOutlined,
    Askcollapse,
    Nodata
  },
  props: {
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    navObj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    keywords: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: () => {
        return 'light'
      }
    },
    sectorExtObj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    searchObj: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup(props: any, context: any) {
    const store = useStore()
    const route = useRoute()

    let towmintimer: any = null
    const pageData: any = reactive({
      cardList: [],
      // 已选入自选股的股票
      inOptionalData: [],
      optionalShares: [],
      optionalSharesGroupData: [],
      treeData: store.state.OptionalList.filter((item: any) => item.groupType !== 0),
      getPopupContainer: (e: HTMLElement) => e.parentNode,
      checkedKeys: [],
      selectedKeys: [],
      visibleInst: {},
      optionalSharesProps: {
        title: 'groupName',
        key: 'id',
        value: 'id'
      },
      PageID: 1,
      pageSize: 20,
      loading: false,
      allloaded: false, // 加载完成标志
      titleInfo: {
        Name: '最新回答',
        Inst: '',
        LastPrice: '',
        increase: 0,
        type: 'all',
        code: ''
      },
      modalVisible: false,
      updateIndex: 0,
      websock: null,
      askcollapsekey: Date.now(),
      tablepopoverkey: {},
      visibleFlag: false,
      isDYZT: route.query.softNameAbbr === 'tzyk'
    })

    watch(
      () => props.token,
      (newV: string | undefined, oldV: string | undefined) => {
        if (newV !== oldV && newV) {
          nextTick(() => {
            onSearch(false)
          })
        }
      },
      { immediate: true }
    )
    let lefttimer: any = null

    function towmintimerFn() {
      towmintimer = null
      towmintimer = setInterval(() => {
        queryupdate()
      }, 120000)
    }
    // 除去自选股 的其他自选分组
    pageData.optionalShares = computed(() => {
      const data = store.state.OptionalList
      const result = data.filter((item: any) => {
        return item.groupType !== 0
      })
      return result
    })
    watch(
      () => store.state.OptionalList,
      (newV: any, oldV: any) => {
        if (!oldV.length && newV.length) {
          pageData.treeData = store.state.OptionalList.filter((item: any) => item.groupType !== 0)
        }
      }
    )
    pageData.inOptionalData = computed(() => {
      const data = (store.state.OptionalList || []).filter((item: any) => {
        return item.groupType === 0
      })
      // 自选股
      let obj: any = {}
      if (data.length) obj = data[0]
      const result = (obj.stockList || []).map((item: any) => item.securityNo + '.' + (item.securityMarket || '').toLowerCase())
      return result
    })
    pageData.optionalSharesGroupData = computed(() => {
      if (pageData.optionalShares.length) {
        const data = (pageData.optionalShares || []).map((item: any) => item.stockList).flat()
        const securityNos = (data || []).map((item: any) => item.securityNo)
        return securityNos
      } else {
        return []
      }
    })
    function onSearch(scroll: boolean) {
      pageData.loading = true
      const data: any = {}
      const keywordsType = (props.keywords || {}).type || null
      data.data = {
        PageID: pageData.PageID,
        PageSize: pageData.pageSize,
        ...props.keywords,
        ...props.sectorExtObj
      }
      const carddata = JSON.parse(JSON.stringify(pageData.cardList))
      // suboff(carddata)
      // pageData.titleInfo.increase = null
      // pageData.titleInfo.LastPrice = null
      // 如果 keywords 里面 股票和关键词 不为空，则清空之前侧边栏的查询条件
      if (!((props.keywords || {}).InstExt || []).length && !((props.keywords || {}).KeyWords || []).length) {
        if (pageData.titleInfo.type === 'gp') {
          data.data.InstExt = [
            {
              Exch: (pageData.titleInfo.Exch || '').toLowerCase(),
              Inst: pageData.titleInfo.code
            }
          ]
        }
        if (pageData.titleInfo.type === 'gn') {
          // 如果是概念，则 传进 SectorExt
          data.data.SectorExt = [
            {
              Exch: (pageData.titleInfo.Exch || '').toLowerCase(),
              Inst: pageData.titleInfo.code
            }
          ]
        }
      } else {
        data.data.SectorExt = []
      }
      // 如果只搜索一个股票，则标题显示股票 最新价 涨跌幅
      // 如果搜索关键词或 搜索多个，则显示 为您找到如下结果：

      if (((props.keywords || {}).InstExt || []).length === 1 && !((props.keywords || {}).KeyWords || []).length) {
        const _data = (props.searchObj || {}).InstExt[0]
        pageData.titleInfo.Exch = (_data.Market || _data.MarketCode).toLowerCase()
        pageData.titleInfo.code = _data.Symbol || _data.Code
        pageData.titleInfo.Inst = _data.Symbol || _data.Code
        pageData.titleInfo.Name = _data.Name
        pageData.titleInfo.type = 'gp'
        subon(pageData.titleInfo)
      } else if (((props.keywords || {}).InstExt || []).length > 1 || ((props.keywords || {}).KeyWords || []).length) {
        pageData.titleInfo.Exch = null
        pageData.titleInfo.code = null
        pageData.titleInfo.Inst = null
        pageData.titleInfo.type = 'all'
        pageData.titleInfo.Name = '为您找到如下结果：'
      }
      if (keywordsType === 'hotKeywords') {
        const filterText = props.keywords.KeyWords[0]
        pageData.titleInfo.Name = `为您找到关键词‘<font style='color: #FA5555'>${filterText}</font>’相关结果：`
      }
      data.headers = {
        token: props.token
      }
      pageData.allloaded = false

      askApi.getInfoSecretarySearch(data).then((res: any) => {
        if ((res.Data || []).length < pageData.pageSize) pageData.allloaded = true
        if ((res.Data || []).length) {
          res.Data.forEach((item: any) => {
            item.ATime = globalsets.formatTime(item.ATime)
            item.QTime = globalsets.formatTime(item.QTime)
            if (((props.keywords || {}).KeyWords || []).length) {
              props.keywords.KeyWords.forEach((filterText: string) => {
                item.AContent = item.AContent.replace(
                  new RegExp(filterText, 'i'),
                  `<font style='color: #FA5555'>${(new RegExp(filterText, 'i').exec(item.AContent) || [])[0]}</font>`
                )
                item.QContent = item.QContent.replace(
                  new RegExp(filterText, 'i'),
                  `<font style='color: #FA5555'>${(new RegExp(filterText, 'i').exec(item.QContent) || [])[0]}</font>`
                )
              })
            }
          })
          clearInterval(towmintimer)
          towmintimer = null
          if (scroll) {
            pageData.cardList = pageData.cardList.concat(res.Data)
          } else {
            const lel: any = document.querySelector('.cardwrap')
            if (lel) {
              lel.scrollTop = 0
            }
            pageData.cardList = res.Data
          }
          context.emit('AQContent', res.Data)
          nextTick(() => {
            subon(pageData.titleInfo)
            settime()
            towmintimerFn()
            pageData.loading = false
          })
        } else {
          if (!scroll) {
            pageData.cardList = []
          }
          pageData.loading = false
        }
      })
    }
    function handleOptionalShares(checkedkeys: any, check: any, row: any, i: number) {
      const e = { id: check.node.eventKey }
      if (!store.state.loginInfo || !store.state.loginInfo.token) {
        stock.gotoClientLogin()
        return
      }
      if (check.checked) {
        // 添加
        addOptionalShares(e, row, i)
      } else {
        removeOptionalShares(e, row, e.id, i)
      }
    }
    async function addOptionalShares(e: any, row: any, i: number) {
      if (!store.state.loginInfo || !store.state.loginInfo.token) {
        stock.gotoClientLogin()
        return
      }
      let g = e
      if (!e && pageData.visibleInst[row.Inst + '' + i]) return
      if (!e) {
        // 如果当前股的下拉框是打开的，则什么操作也不做
        const data = store.state.OptionalList.filter((item: any) => item.groupType === 0)
        g = data[0]
      }
      const res = await stock.addStock(g, row, store.state.loginInfo)
      if (res === 1) {
        store.commit('setChangeOptionalTime', Date.now())
        if (!e) {
          // message.success('已成功添加到自选股')
        }
      }
    }
    async function removeOptionalShares(e: any, row: any, id: string, i: number) {
      if (!store.state.loginInfo || !store.state.loginInfo.token) {
        stock.gotoClientLogin()
        return
      }
      let g = e
      if (!e && pageData.visibleInst[row.Inst + '' + i]) {
        pageData.visibleInst[row.Inst + '' + i] = false
        return
      }
      if (!e) {
        // 如果当前股的下拉框是打开的，则什么操作也不做
        g = store.state.OptionalList.filter((item: any) => item.groupType === 0)
      }
      const ids: any = []
      if (id) {
        ids.push(id)
      } else {
        ids.push(g[0].id)
      }
      const res = await stock.removeStock(ids, row, store.state.loginInfo)
      if (res === 1) {
        store.commit('setChangeOptionalTime', Date.now())
        if (!e) {
          // message.success('已从自选股中删除')
        }
      }
    }
    function visibleChange(visible: any, row: any, i: number, e: any) {
      if (pageData.visibleInst[row.Inst + '' + i] && !visible) {
        setTimeout(() => {
          pageData.visibleInst[row.Inst + '' + i] = visible
        }, 500)
        return
      }
      pageData.visibleInst[row.Inst + '' + i] = visible
      if (visible) {
        // 所有 【除去自选股】的 自选分组
        const inst = row.Inst
        const data = store.state.OptionalList.filter((item: any) => {
          return item.groupType !== 0
        })
        const ids: number[] = []
        for (let i = 0; i < data.length; i++) {
          const item = data[i]
          if (item.stockList.length) {
            const arr = (item.stockList || []).map((o: any) => o.securityNo)
            if (arr.indexOf(inst) > -1) {
              ids.push(item.id)
            }
          }
        }
        pageData.checkedKeys = ids

        const lel: any = document.querySelector('.cardwrap')
        lel.addEventListener('scroll', hanldescrollFn)
        // setscroll()
      } else {
        pageData.visibleInst = {}
        const lel: any = document.querySelector('.cardwrap')
        // if (!lel) return
        lel.removeEventListener('scroll', setscroll)
      }
    }
    function setscroll() {
      nextTick(() => {
        const lel: any = document.querySelector('.cardwrap')
        if (!lel) return
        if (!Object.keys(pageData.visibleInst).length) {
          lel.removeEventListener('scroll', hanldescrollFn)
        } else {
          lel.addEventListener('scroll', hanldescrollFn)
        }
      })
    }
    function hanldescrollFn() {
      const obj: any = pageData.visibleInst
      for (const key in obj) {
        pageData.visibleInst[key] = false
        pageData.tablepopoverkey[key] = Date.now()
      }
      const lel: any = document.querySelector('.cardwrap')
      if (!lel) return
      lel.removeEventListener('scroll', hanldescrollFn)
    }
    function gotodetail(row: any) {
      if (!row.Inst) row.Inst = row.code
      stock.gotoDetail(row)
    }
    function settime() {
      const lel: any = document.querySelector('.cardwrap')
      lel.onscroll = () => {
        const offsetHeight = lel.offsetHeight
        const scrollTop = lel.scrollTop
        const scrollHeight = lel.scrollHeight
        if (offsetHeight + scrollTop - scrollHeight >= -60 && scrollTop > 0) {
          // 需要执行的代码
          // suboff(pageData.cardList)
          if (!lefttimer && !pageData.allloaded) {
            pageData.PageID++
            pageData.loading = true
            lefttimer = setTimeout(function () {
              onSearch(true)
              // getData('')
              lefttimer = null
              pageData.loading = false
            }, 500)
          }
          if (pageData.allloaded) {
            pageData.loading = false
          }
          // 调用list 原本的数据请求函数
        }
      }
    }
    function websocketonopen() {
      const data = {
        OrgCode: 'rh',
        Token: 'e9252a64-6ac8-4bf8-9725-6f106f682908',
        AppName: 'fdzqapp',
        AppVer: 'V3.0.9',
        AppType: 'ios',
        Tag: 'af91c60a-1acc-4150-9014-d11086cb9489'
      }
      websocketsend(JSON.stringify(data))
      subon(pageData.cardList)
    }
    function websocketsend(msg: any) {
      if (pageData.websock && pageData.websock.readyState) {
        pageData.websock.send(msg)
      }
    }
    function bkChange(item) {
      console.log('打印板块相关===', item)
      if (item?.toUpperCase() == 'AHZSECTOR' || item?.toUpperCase() == 'AHZBSECTOR') {
        return 'AHZBSECTOR'
      }
      return item
    }

    ws.websocket.on('onHQLIST', msg => {
      if (pageData.cardList && pageData.cardList.length) {
        pageData.cardList.forEach((item: any) => {
          msg?.QuoteData?.DynaData?.forEach(msgItem => {
            if (item.Inst !== msgItem.InstrumentID || item.Exch.toLowerCase() !== msgItem.ExchangeID.toLowerCase()) return
            item.LastPrice = msgItem.LastPrice || 0
            item.increase = msgItem.UpdownRate * 100 || 0
          })
        })
      }
      pageData.cardList.slice(0, 0)
    })
    ws.websocket.on('onDYNA', msg => {
      msg?.QuoteData?.DynaData?.forEach(msgItem => {
        msgItem.ExchangeID = bkChange(msgItem.ExchangeID)
        pageData.titleInfo.Exch = bkChange(pageData.titleInfo.Exch)
        if (pageData.titleInfo.code !== msgItem.InstrumentID || pageData.titleInfo.Exch.toLowerCase() !== msgItem.ExchangeID.toLowerCase()) return
        // console.log('打印分时数据===',msg.QuoteData.DynaData)
        pageData.titleInfo.LastPrice = msgItem.LastPrice || 0
        pageData.titleInfo.increase = msgItem.UpdownRate * 100 || msgItem.Updown * 100 || 0
      })

    })
    watch(
      () => props.searchObj,
      (val: any) => {
        suboff(pageData.titleInfo)
      },
      {
        deep: true,
        immediate: true
      }
    )
    watch(
      () => pageData.cardList,
      (newV: any, oldV: any) => {
        suboff(oldV)
        nextTick(() => {
          subon(newV)
        })
      },
      {
        immediate: true
      }
    )
    watch(
      () => props.navObj,
      (newV: any, oldV: any) => {
        const titledata = JSON.parse(JSON.stringify(pageData.titleInfo))
        const carddata = JSON.parse(JSON.stringify(pageData.cardList))
        // console.log('打印数据====',titledata,carddata,newV)
        // 清空定时器
        suboff(titledata)
        const data = props.navObj
        pageData.titleInfo.type = data.type
        pageData.titleInfo.Name = data.type === 'gn' ? data.Name : data.type === 'gp' ? data.Name : '最新回答'
        pageData.titleInfo.Inst = data.type === 'gp' ? data.Symbol : ''
        pageData.titleInfo.Exch = data.type === 'gn' ? data.Exch : data.type === 'gp' ? (data.Market || '').toLowerCase() : ''
        // 用来订阅消息
        pageData.titleInfo.code = data.type === 'gp' ? data.Symbol : data.type === 'gn' ? data.Inst : ''
        pageData.titleInfo.DynaData = null
        pageData.titleInfo.StatisticsData = null
        // NEWSECTORLIST
        pageData.PageID = 1
        // console.log('订阅===pageData.titleInfo',pageData.titleInfo)
        subon(pageData.titleInfo)
        if (props.token) {
          onSearch(false)
        }
      }
    )
    // 订阅 / 取消订阅问答数据
    // 订阅
    const removeDuplicateObj = (arr: any) => {
      // 缓存用于记录
      const newArr: any = []
      for (const t of arr) {
        // 检查缓存中是否已经存在
        if (newArr.find((c: any) => c.Inst === t.Inst && c.Exch === t.Exch)) {
          continue
        }
        newArr.push(t)
      }
      // 记录结果就是过滤后的结果
      return newArr
    }
    function subon(list: any) {
      // console.log('打印订阅数据===',list,Object.prototype.toString.call(list))
      if (Object.prototype.toString.call(list) === '[object Array]') {
        nextTick(() => {
          // 列表去重
          const data = removeDuplicateObj(list)
          let stockList: Array<object> = []
          let keyList: Array<string> = []
          data.forEach((item: any) => {
            let obj = {
              symbol: item.Inst,
              market: item.Exch,
            } as object
            let str = item.Inst + item.Exch
            stockList.push(obj)
            keyList.push(str)
          })
          ws.websocket.safeSubscribeList(keyList, stockList)
        })
      } else {
        ws.websocket.safeSubscribeDYNA(list.code, list.Exch)

      }
    }
    // 取消订阅
    function suboff(data: any) {
      // if(Object.prototype.toString.call(data) === '[object Array]'){
      const _data = data || pageData.cardList
      if (!_data.length) return
      let stockList: Array<object> = []
      let keyList: Array<string> = []
      data.forEach((item: any) => {
        let obj = {
          symbol: item.Inst,
          market: item.Exch,
        } as object
        let str = item.Inst + item.Exch
        stockList.push(obj)
        keyList.push(str)
      })
      ws.websocket.safeUnsubscribeList(keyList, stockList)
      // }else{
      // ws.websocket.safeUnsubscribeDYNA(data.code,data.Exch)
      // }
    }
    function queryupdate() {
      // pageData.loading = true
      const data: any = {}
      data.data = {
        PageID: 1,
        PageSize: 200,
        ...props.keywords,
        ...props.sectorExtObj
      }
      // 如果 keywords 里面 股票和关键词 不为空，则清空之前侧边栏的查询条件
      if (!((props.keywords || {}).InstExt || []).length && !((props.keywords || {}).KeyWords || []).length) {
        if (pageData.titleInfo.type === 'gp') {
          data.data.InstExt = [
            {
              Exch: pageData.titleInfo.Exch,
              Inst: pageData.titleInfo.code
            }
          ]
        }
        if (pageData.titleInfo.type === 'gn') {
          // 如果是概念，则 传进 SectorExt
          data.data.SectorExt = [
            {
              Exch: pageData.titleInfo.Exch,
              Inst: pageData.titleInfo.code
            }
          ]
        }
      } else {
        data.data.SectorExt = []
      }
      data.headers = {
        token: props.token
      }
      askApi.getInfoSecretarySearch(data).then((res: any) => {
        const postsId = (res.Data || []).map((item: any) => item.ID)
        if (!(postsId || []).length) return
        // 如果查找出来是第0条，则没有数据更新
        if (!(pageData.cardList || []).length && (postsId || []).length) {
          pageData.modalVisible = true

          pageData.updateIndex = res.Data.length
          setTimeout(() => {
            pageData.modalVisible = false
          }, 10000)
          return false
        }
        if ((pageData.cardList || []).length && postsId.indexOf(((pageData.cardList || [])[0] || {}).ID) === 0) return

        if ((pageData.cardList || []).length) {
          if (postsId.indexOf(pageData.cardList[0].ID) > 0) {
            // 有200条以内的数据更新
            pageData.updateIndex = postsId.indexOf(pageData.cardList[0].ID) + 1
          } else {
            pageData.updateIndex = postsId.length
          }
          pageData.modalVisible = true
          setTimeout(() => {
            pageData.modalVisible = false
          }, 10000)
        }
      })
    }
    function freshdata() {
      const carddata = JSON.parse(JSON.stringify(pageData.cardList))
      suboff(carddata) // 先取消订阅
      pageData.modalVisible = false // 关闭弹框
      pageData.PageID = 1
      onSearch(false)
    }
    onMounted(() => {
      window.addEventListener('resize', () => {
        pageData.askcollapsekey = Date.now()
      })
    })
    return {
      ...toRefs(pageData),
      onSearch,
      route,
      handleOptionalShares,
      visibleChange,
      addOptionalShares,
      removeOptionalShares,
      freshdata,
      getNumber: globalsets.getNumber,
      getNumber2: globalsets.getNumber2,
      getPencent: globalsets.getPencent,
      gotodetail
    }
  }
})
